import React, { Component } from 'react';
import { Link, Route} from 'react-router-dom';

import './App.css';
import Home from './Home';
import About from './About';
import Dogs from './Dogs';

class App extends Component {

  constructor(props) {
    super(props);

    this.hideNavBar = this.hideNavBar.bind(this);

  }


  hideNavBar(e) {
    document.getElementsByClassName('navbar-collapse')[0].classList.remove('show');  
  }

  render() {
    return (
      <div className="App">
          <header className="App-header">
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
              <div className="nameContainer">
                <Link className="navbar-brand" to="/Puppedia" onClick={this.hideNavBar}>Puppedia</Link>
              </div>
              <button className="navbar-toggler" onClick={this.showNavBar} type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                  <li className="nav-item">
                    <Link className="nav-link" to="/Puppedia" onClick={this.hideNavBar}><i className="fa fa-home"></i> Home<span className="sr-only"></span></Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/Puppedia/about" onClick={this.hideNavBar}><i className="fa fa-info-circle"></i> About</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/Puppedia/dogs" onClick={this.hideNavBar}><i className="fa fa-paw"></i> Dogs</Link>
                  </li>
                </ul>
              </div>
            </nav>
        </header>
        <Route exact={true} path="/Puppedia" component={Home} />
        <Route path="/Puppedia/about" component={About} />
        <Route path="/Puppedia/dogs" component={Dogs} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js